<template>
  <div class="full-page d-flex flex-column">
    <!-- Buttons -->
    <div class="button-bar row row-cols-2 row-cols-sm-4 g-2 p-3 bg-light m-0">
      <div class="col" v-for="button in buttons" :key="button.page">
        <button
          class="btn w-100"
          :class="currentPage === button.page ? button.activeClass : button.outlineClass"
          @click="currentPage = button.page"
        >
          {{ button.label }}
        </button>
      </div>
    </div>

    <!-- Page Content Area -->
    <div class="flex-fill content-area p-4 bg-transparent overflow-auto">
      <div v-if="currentPage === 'student-payment'">
        <StudentPayment />
      </div>

      <div v-else-if="currentPage === 'teacher-payment'">
        <TeacherPayment />
      </div>

      <div v-else-if="currentPage === 'institute-payment'">
        <InstitutePayment />
      </div>

      <div v-else-if="currentPage === 'payment-history'">
        <PaymentHistory />
      </div>
    </div>
  </div>
</template>

<script>
import StudentPayment from '@/components/InstituteDashboard/PaymentPages/StudentPayment.vue';
import TeacherPayment from '@/components/InstituteDashboard/PaymentPages/TeacherPayment.vue';
import InstitutePayment from '@/components/InstituteDashboard/PaymentPages/InstitutePayment.vue';
import PaymentHistory from '@/components/InstituteDashboard/PaymentPages/PaymentHistory.vue';

export default {
  components: {
    StudentPayment,
    TeacherPayment,
    InstitutePayment,
    PaymentHistory
  },
  data() {
    return {
      currentPage: 'student-payment',
      buttons: [
        {
          page: 'student-payment',
          label: 'Student Payment',
          activeClass: 'btn-primary',
          outlineClass: 'btn-outline-primary'
        },
        {
          page: 'teacher-payment',
          label: 'Teacher Payment',
          activeClass: 'btn-secondary',
          outlineClass: 'btn-outline-secondary'
        },
        {
          page: 'institute-payment',
          label: 'Institute Payment',
          activeClass: 'btn-success',
          outlineClass: 'btn-outline-success'
        },
        {
          page: 'payment-history',
          label: 'Payment History',
          activeClass: 'btn-warning',
          outlineClass: 'btn-outline-warning'
        }
      ]
    };
  }
};
</script>

<style scoped>
.full-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* background-color: #f8f9fa; */
}

.content-area {
  flex-grow: 1;
  overflow-y: auto;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .button-bar {
    position: fixed;
    padding: 1rem 0.5rem;
  }

  .button-bar .btn {
    font-size: 0.9rem;
    padding: 0.5rem 0.75rem;
  }

  .content-area {
    margin-top: 10dvh !important;
    padding: 1rem;
    margin-top: 10%;
  }
}
</style>
